import * as actions from "../action.constants";

const initialState = {
  modal: {
    open: false,
    title: "",
    description: "",
  },
  onConfirmCallback: () => {},
  scope: [],
  controllersForScope: [],
};

const toggleModal = (state, action) => {
  return {
    ...state,
    modal: {
      ...state.modal,
      ...action.modal,
    },
    onConfirmCallback: action.callback,
  };
};

const modalReset = (state) => {
  return {
    ...state,
    ...initialState,
  };
};

const storeScope = (state, action) => {
  return {
    ...state,
    scope: action.payload || [],
  };
};

const storeControllersForScope = (state, action) => {
  return {
    ...state,
    controllersForScope: action.payload || [],
  };
};

const handlers = {
  [actions.TOGGLE_MODAL]: toggleModal,
  [actions.MODAL_RESET]: modalReset,
  [actions.STORE_SCOPE]: storeScope,
  [actions.STORE_CONTROLLERS_FOR_SCOPE]: storeControllersForScope,
};

export default (state = initialState, action) => {
  const handler = handlers[action.type];
  if (typeof handler === "undefined") return state;
  return handler(state, action);
};
